export class TextValueItem {
	text: string;
	value: number | string;
}
export class TextValueExtended extends TextValueItem {
	value: number;
	code: string;
	description: string;
}